export default class BasePage {
  loadEssentials() {
    return Promise.all(
      [
        import(/* webpackChunkName: "header" */ '@/partials/header/index.js'),
        import(/* webpackChunkName: "footer" */ '@/partials/footer/index.js')
      ]
    )
  }

  constructor(onInit) {
    this.loadEssentials()
      .then(onInit)
  }
}
